import React from 'react';
import styled from "styled-components";

const ErrorPageWrapper = styled.div`
  width: 100%;
`;

class ErrorBoundary extends React.Component<any> {
    state: any;

    constructor(props: any) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }
    componentDidCatch(error: any, errorInfo: any) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    public refreshPage = (): void => {
        window.location.reload();
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <ErrorPageWrapper>
                    <h1>Error 500</h1>
                </ErrorPageWrapper>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
